var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { active: _vm.active },
      on: {
        "update:active": function($event) {
          _vm.active = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "div",
        { staticClass: "box", staticStyle: { "min-height": "700px" } },
        [
          _c("h1", { staticClass: "title" }, [
            _vm._v(" Schedule Makeup Class "),
            _c("p", { staticClass: "subtitle" }, [
              _vm._v(
                " Schedule a makeup and apply to this missed class specifically. "
              )
            ])
          ]),
          _c("form", { on: { submit: _vm.handleSubmit } }, [
            _vm.missed.classData
              ? _c("div", { staticClass: "box" }, [
                  _c("strong", [_vm._v("Missed Class:")]),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.classTypeFromUid(_vm.missed.classData.classType)
                      ) +
                      " (" +
                      _vm._s(
                        _vm.classLevelFromUid(_vm.missed.classData.classLevel)
                      ) +
                      ")"
                  ),
                  _c("br"),
                  _vm._v(
                    " " + _vm._s(_vm.registrationFormat(_vm.missed.classData))
                  ),
                  _c("br"),
                  _vm._v(
                    " " + _vm._s(_vm.defaultFormatDate(_vm.missed.missedDate))
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(_vm.missed.creditsUsed) +
                      " of " +
                      _vm._s(_vm.missed.credits) +
                      " credits used "
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Makeup Class")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _vm.makeup.makeupClass
                    ? _c("div", { staticClass: "tags has-addons" }, [
                        _c("span", { staticClass: "tag is-medium" }, [
                          _vm._v(
                            _vm._s(_vm.formatClass(_vm.makeup.makeupClass))
                          )
                        ]),
                        _c("span", { staticClass: "tag is-medium is-info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.teacherNameFromUid(
                                _vm.makeup.makeupClass.instructor
                              )
                            )
                          )
                        ]),
                        _c("a", {
                          staticClass: "tag is-medium is-delete",
                          on: { click: _vm.removeSelectedClass }
                        })
                      ])
                    : _vm._e(),
                  _vm.potentialClasses.length > 0
                    ? _c("class-autocomplete", {
                        attrs: {
                          useClasses: _vm.potentialClasses,
                          excludeFull: true,
                          forMakeup: true,
                          denoteNotRecommended: true
                        },
                        on: { classSelected: _vm.handleClassSelected }
                      })
                    : _vm._e(),
                  _vm.potentialClasses.length === 0 && !_vm.makeup.makeupClass
                    ? _c("div", { staticClass: "content has-text-grey" }, [
                        _vm._v(
                          " No suitable makeups were found. Try adding a makeup to split between multiple missed classes. "
                        )
                      ])
                    : _vm._e(),
                  _vm.alreadyScheduledClass
                    ? _c("div", { staticClass: "content has-text-grey" }, [
                        _vm._v(
                          " This class is already scheduled. Please try a different date. "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Date of Makeup Class")
              ]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("class-appointment-selector", {
                    ref: "makeupClassSelector",
                    attrs: {
                      forMakeups: true,
                      dancer: _vm.currentDancer,
                      selectableClasses: _vm.selectableClasses
                    },
                    on: {
                      selected: _vm.handleSelectedAppointment,
                      removed: _vm.removeSelectedAppointment,
                      loadMore: _vm.handleLoadMore
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "field is-grouped is-grouped-right" }, [
              _c("div", { staticClass: "control" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    class: { "is-loading": _vm.isLoading },
                    attrs: { disabled: !_vm.readyToSchedule }
                  },
                  [_vm._v(" Schedule ")]
                )
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }